import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import {
  StatsEventTableContainer,
  StatsEventTableSectionBody,
  StatsEventTableSection,
  EventCreatorProfile,
  EventTimeFieldDiv,
  EventUserProfile
} from './styles'
import { useTheme } from 'styled-components'
import { EmptyActivityIcon } from '../SvgIcons'
import eventCreatorAvatar from '../../../assets/images/EventCreatorAvatar.png'

const StatsEventTable = (props) => {
  const {
    users,
    tradeList,
    isLoadMore
  } = props

  const theme = useTheme()
  const navigate = useNavigate()

  const [eventRows, setEventRows] = useState([])

  useEffect(() => {
    if (tradeList?.length > 0) {
      let rows = tradeList.map((event, idx) => (
        <tr key={idx}>
          <td>{event.methodType === 0 ? 'Buy' : 'Sale'}</td>
          <td>{renderItemField(event)}</td>
          <td>{renderPriceField(event)}</td>
          <td>{event.quantity}</td>
          <td>{event.from && renderUser(event.from)}</td>
          <td>{event.to && renderUser(event.to)}</td>
          <td>{event.timeSpan}</td>
        </tr>
      ))
      setEventRows(tt => rows);
    } else {
      setEventRows(t => []);
    }
  }, [tradeList])

  const renderItemField = (trade) => {
    let nftAvatar = trade?.nftImage || eventCreatorAvatar;
    return (
      <EventCreatorProfile
        onClick={() => console.log('Item click')}
      >
        <img src={nftAvatar} alt='nft' />
        <div>
          {/* <div className="title">{tt?.creatorName}</div> */}
          <div className="value" onClick={() => handleOpenItem(trade)}>{trade?.nftTitle || '---'}</div>
        </div>
      </EventCreatorProfile>
    )
  }

  const renderUser = (address) => {
    let user = users.find(user => user.address.toLowerCase() === address.toLowerCase())

    let userAvatar = user?.avatarURI || eventCreatorAvatar;
    return (
      <EventUserProfile
        isEnable={user}
        onClick={() => user && navigate(`/profile/${address.toLowerCase()}`)}
      >
        <img src={userAvatar} alt='nft' />
        <div>
          <div className="value">{user?.name || '---'}</div>
        </div>
      </EventUserProfile>
    )
  }

  const handleOpenItem = (item) => {
    navigate(`/products/${item.collectionAddress}/${item.nftId}/collection`)
  }

  const renderPriceField = (activity) => {
    switch (activity.paymentName) {
      case 'HyperX':
        return (
          <div className="price-div">
            <img src={theme.images.chainTokenIcon} alt='hyperX' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BNB':
        return (
          <div className="price-div">
            <img src={theme.images.binanceTokenIcon} alt='bnb' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BUSD':
        return (
          <div className="price-div">
            <img src={theme.images.binanceUsdIcon} alt='busd' />
            <div>{activity.price}</div>
          </div>
        )
      default:
        break;
    }
  }

  return (
    <StatsEventTableContainer>
      <StatsEventTableSectionBody>
        <StatsEventTableSection>
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Item</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>From</th>
                <th>To</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {eventRows?.length > 0 ? (
                <>
                {eventRows}
                {isLoadMore && [...Array(6).keys()].map((i) => (
                  <tr key={i}>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton height={30} /></td>
                  </tr>
                ))}
                </>
                ) : (
                <tr>
                  <td colSpan={8} style={{ paddingTop: '100px' }}>
                    <div className="no-result">
                      <EmptyActivityIcon />
                      <div className="empty-text">There Are No stats Yet</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </StatsEventTableSection>
      </StatsEventTableSectionBody>
    </StatsEventTableContainer>
  )
}

export default StatsEventTable
